/*
 * Copyright (c) 2025. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export const IDS_QUERY_PARAM = 'cids';
export const BASE_CONFIG_ID = 'bcid';
export const SHOW_ONLY_DIFF = 'showOnlyDiff';
export const DELIMITER_ID_GROUPS = ';';
export const DELIMITER_ID_VERSION = ':';
export const DELIMITER_VERSIONS = ',';
export var CompareResultsType;
(function (CompareResultsType) {
    CompareResultsType["PV_COSTING_RESULTS"] = "pv_costing_results";
    CompareResultsType["ESS_COSTING_RESULTS"] = "ess_costing_results";
    CompareResultsType["PV_SIM_RESULTS"] = "pv_sim_results";
    CompareResultsType["PLANT_SIM_RESULTS"] = "plant_sim_results";
})(CompareResultsType || (CompareResultsType = {}));
export const plantSimCompareLookType = {
    prices: 'prices',
    ess: 'ess',
    thermal: 'thermal',
    pv: 'pv',
};
//# sourceMappingURL=compare.js.map